import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NbButtonModule, NbTooltipModule } from '@nebular/theme';

@Component({
  selector: 'app-delete-button-renderer',
  template: `
    <button [nbTooltip]="'Delete' | translate"
      nbTooltipPlacement="bottom"
      nbButton
      ghost
      (click)="delete($event)"
    >
      <fa-icon [icon]="['fal', 'trash-can']"></fa-icon>
    </button>
  `,
  styles: [`
    fa-icon {
      color: #ff3939;
      font-size: 20px;
    }
    button {
      background: transparent !important;
      border: none !important;
      padding: 0 !important;
      height: 36px;
      width: 36px;
      color: #ff3939;
      position: absolute !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      transition: color 0.3s ease;
    }
    button:hover fa-icon {
      color: #ff3939;
    }
  `],
  standalone: true,
  imports: [
    NbButtonModule,
    NbTooltipModule,
    FontAwesomeModule,
    TranslateModule,
  ],
})
export class DeleteRendererComponent implements ICellRendererAngularComp {

  @ViewChild('container', { read: ViewContainerRef })
  public container!: ViewContainerRef;
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  public delete(event: MouseEvent): void {
    event.stopPropagation();
    this.params.context.delete(
      this.params.node.data.id,
      this.params.node.data.name || this.params.node.data.label,
    );
  }

}
